import fetch from 'isomorphic-fetch';

const DRUPAL_URL = "https://api.crckingston.org.au/api/views/";
const DRUPAL_SEARCH_SERMONS = DRUPAL_URL+"all_sermons_api?filters";
const DRUPAL_WEBSITE_CONTENT = DRUPAL_URL+"all_website_content_api?filters[component]=";

const DRUPAL_WEBFORM_SUBMISSION = "https://api.crckingston.org.au/webform_submission/submission";

//Example suffix: all_sermons_api?filters[preacher]=keith&filters[title]=reality

//API uses Services and Services views on the drupal 7 instance

export function getFromDrupalAPI(url, callback){
  fetch(DRUPAL_URL+url)
  .then(resp => resp.json())
  .then(function(data) {
      callback(data);
    })
  .catch(function(error){
    console.log(error);
  })
}

export function searchDrupalSermons(query, type, callback){
  fetch(DRUPAL_SEARCH_SERMONS+'['+type+']='+query)
  .then(resp => resp.json())
  .then(function(data) {
      callback(data);
    })
  .catch(function(error){
    console.log(error);
  })
}

export function getWebsiteContent(component, callback){
  fetch(DRUPAL_WEBSITE_CONTENT+component)
  .then(resp => resp.json())
  .then(function(data) {
      callback(data);
    })
  .catch(function(error){
    console.log(error);
  })
}

export function postToWebform(formData, callback){
  fetch(DRUPAL_WEBFORM_SUBMISSION, {
    method: "POST",
    body: formData
  })
  .then(resp => resp.json())
  .then(function(data) {
    callback(data);
  })
  .catch(function(error){
    console.log(error);
  })
}
